import { render, staticRenderFns } from "./InfoItemTitle.vue?vue&type=template&id=0016e5ac&"
import script from "./InfoItemTitle.vue?vue&type=script&lang=js&"
export * from "./InfoItemTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports